import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import logo from '../../public/static/images/logo.png';
import Button from '../Button';

const Navbar = ({ isHomepage = false }) => {
  const router = useRouter();

  const handleClick = useCallback(
    (e) => {
      if (isHomepage) {
        // scroll to signup
        e.preventDefault();
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            const signupPanel = document.getElementById('hero-section');
            if (signupPanel) {
              const y =
                signupPanel.getBoundingClientRect().top +
                window.pageYOffset -
                100;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
            // Focus on email input after navigation and scrolling
            setTimeout(() => {
              const emailInput = document.getElementById(
                'newsletter-email-signup'
              );
              if (emailInput) {
                emailInput.focus();
              }
            }, 500);
          }, 50);
        }
      } else {
        // navigate to home
        router.push('/');
      }
    },
    [router, isHomepage]
  );

  return (
    <div className={styles.navbar} role="banner">
      <div
        className={styles.logoWrapper}
        onClick={!isHomepage ? () => router.push('/') : undefined}
      >
        <img className={styles.logo} src={logo} alt="Island logo" />
      </div>
      <Button
        className={styles.button}
        onClick={handleClick}
        text="Get island"
        height={38}
        backgroundColor="#0F0"
        shadowColor="#00D900"
        color="black"
      />
    </div>
  );
};

export default Navbar;
